import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"place"}/>
}
